import { Controller } from "@hotwired/stimulus";

export default class UIFilter extends Controller {
  static targets = ["source", "item", "noResults"];

  connect() {}

  filter(event) {
    let filterTerm = this.sourceTarget.value.toLowerCase();
    let visibleCount = 0;

    if (this.hasItemTarget) {
      this.itemTargets.forEach((el, i) => {
        let filterableKey = el.innerText.toLowerCase();

        // Check for case-insensitive substring match
        let isVisible = filterableKey.includes(filterTerm);
        el.classList.toggle("hidden", !isVisible);

        if (isVisible) {
          visibleCount++;
        }
      });
    }

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.toggle("hidden", visibleCount > 0 || filterTerm === "");
    }
  }
}
